// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DiscoveryAuthModeSchema = z.enum(['UNKNOWN','UNAUTHENTICATED','AUTHENTICATED'] as const);

export type DiscoveryAuthModeType = `${z.infer<typeof DiscoveryAuthModeSchema>}`

export default DiscoveryAuthModeSchema;
